import { ErrorMessage } from '@wyz/ui';
import clsx from 'clsx';
import { Trans } from '~/common/context';
import { IUserCustomer } from '~/common/types';
import {
  PurchaseTable,
  WcwTableHeader,
  WcwTyreGroupRow,
} from '~/purchase/components';
import { IWcwOffer } from '~/purchase/types';

type Props = {
  offers: Array<IWcwOffer>;
  customer: IUserCustomer;
  viewPrice: boolean;
};

function WcwOffers({ offers, customer, viewPrice }: Props) {
  if (offers.length === 0) {
    return (
      <ErrorMessage
        title={<Trans i18nKey='app.purchase.search_page.no_results' />}
      />
    );
  }

  return (
    <>
      <PurchaseTable
        className={clsx('wcw-table', !viewPrice && 'wcw-table--hide-price')}
      >
        <WcwTableHeader viewPrice={viewPrice} />
      </PurchaseTable>
      {offers.map((product) => (
        <WcwTyreGroupRow
          key={product.id}
          product={product}
          customer={customer}
          viewPrice={viewPrice}
        />
      ))}
    </>
  );
}

export default WcwOffers;
